// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { useState, useEffect, useRef, useCallback } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { makeFooterVisibleHeight } from '../../../redux/selectors/mainLayoutSelector/mainLayoutSelector';
import JumpToAnswerIcon from '../../../assets/images/JumpToAnswer.svg';
import { animateScroll as scroll } from 'react-scroll';
import { FormattedMessage } from 'react-intl';
import { convertToObject } from 'typescript';

const S = {
  JumpToAnsContainer: styled.div`
    position: fixed;
    right: 46px;
    transition: bottom 0.5s ease-in;
  `,
  JumpToAnswerIcon: styled.img.attrs({ src: JumpToAnswerIcon })`
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  `,
  JumpButton: styled.button`
    padding: 0;
    background-color: #666666;
    border-radius: 100%;
    cursor: pointer;
  `,
  PopupContainer: styled.div`
    display: flex;
    flex-direction: column;
    position: absolute;
    left: -200px;
    top: -73px;
  `,
  Triangle: styled.div`
    width: 0;
    margin-left: 193px;
    border-style: solid;
    border-width: 9px 7px 0 7px;
    border-color: #434343 transparent transparent transparent;
    border-radius: 1px;
  `,
  NotionContent: styled.p`
    padding: 12px 15px;
    font-size: 14px;
    line-height: 20px;
    color: #FFFFFF;
    background: #434343;
    border-radius: 4px;
    text-align: center;
    margin: 0 -15px 0 130px;
  `
}

const ScrollToTop = (JumpButtonProps: React.ComponentPropsWithRef<'div'>): JSX.Element => {

  const [isPopupShow, setPopupShow] = useState(false);
  const [showIcon, setShowIcon] = useState(false);
  const footerVisibleHeight = useSelector(makeFooterVisibleHeight());
  const NAVIGATION_TOP_OFFSET = -100;

  const jump = () => {
    scroll.scrollTo(0, { offset: NAVIGATION_TOP_OFFSET });
  }

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setShowIcon(true);
      } else {
        setShowIcon(false);
      }
    };
    document.addEventListener('scroll', handleScroll);
    return () => document.removeEventListener('scroll', handleScroll);
  }, [showIcon]);

  return showIcon ? (
    <S.JumpToAnsContainer {...JumpButtonProps} style={{ bottom: (footerVisibleHeight + 24) + 'px' }}>
      <S.JumpButton onClick={() => jump()} onMouseEnter={() => setPopupShow(true)} onMouseLeave={() => setPopupShow(false)}>
        <S.JumpToAnswerIcon />
      </S.JumpButton>
      {isPopupShow && <S.PopupContainer>
        <S.NotionContent>
          <FormattedMessage id="K006" />
        </S.NotionContent>
        <S.Triangle />
      </S.PopupContainer>}
    </S.JumpToAnsContainer>
  ) : (<></>)
}

export default ScrollToTop;
